import Route from '@ember/routing/route';

export default class ReplacementMediaRoute extends Route {}
